import React, { useEffect, useRef, useState } from 'react';
import cn from 'classnames';

import { TSelectOptionType } from '../../Select.types';
import { IInvisibleItemsProps } from './InvisibleItems.types';

import { EChipsSelectMenuPlacement } from '../../../GroupSelect/enum';
import SelectValue from '../SelectValue';

import './InvisibleItems.scss';

const DEFAULT_MAX_WIDTH = 360;
const PADDING_WIDTH = 10;

const InvisibleItems: React.FC<IInvisibleItemsProps> = ({
	invisibleItems,
	removeHandler,
	menuPlacement,
	containerRef,
	maxMenuChipsHeight,
	menuChipsWidth,
	readOnly,
}) => {
	const wrapperRef = useRef<HTMLDivElement>(null);
	const wrapperWidth = containerRef.current?.offsetWidth;
	const menuWidth = menuChipsWidth || wrapperWidth || DEFAULT_MAX_WIDTH;
	const selectItemsRefs = useRef<any>([]);
	const [listOverflows, setListOverflows] = useState(new Array(invisibleItems.length).fill(true));

	const classNameWrapper = cn('f5gChipsInvisibleItemsWrapper', {
		'f5gChipsInvisibleItemsTopEnd': menuPlacement === EChipsSelectMenuPlacement.topEnd,
		'f5gChipsInvisibleItemsBottomEnd': menuPlacement === EChipsSelectMenuPlacement.bottomEnd,
		'f5gChipsInvisibleItemsTop': menuPlacement === EChipsSelectMenuPlacement.top,
		'f5gChipsInvisibleItemsBottom': menuPlacement === EChipsSelectMenuPlacement.bottom,
	});

	const removeItem = (option: TSelectOptionType) => {
		removeHandler(option);
		setListOverflows(new Array(invisibleItems.length - 1).fill(true));
	};

	useEffect(() => {
		if (!wrapperRef.current) return;

		const scrollWidth = wrapperRef.current?.offsetWidth - wrapperRef.current?.clientWidth;

		setListOverflows((prevState) =>
			prevState.map((isOverflow, index) => {
				return selectItemsRefs.current[index].current?.offsetWidth
					>= menuWidth - PADDING_WIDTH - scrollWidth;
			}),
		);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selectItemsRefs, invisibleItems, wrapperRef]);

	return (
		<div
			ref={wrapperRef}
			className={classNameWrapper}
			data-testid='invisible-items-wrapper'
			style={{
				width: `${menuWidth}px`,
				maxHeight: `${maxMenuChipsHeight}px`,
			}}
		>
			{invisibleItems.map((option, index) => {
				selectItemsRefs.current[index] = selectItemsRefs.current[index] || React.createRef();

				return (
					<SelectValue
						key={option?.label + index.toString()}
						isOverflow={listOverflows[index]}
						option={option}
						readOnly={readOnly}
						removeHandler={removeItem}
						selectItemRef={selectItemsRefs.current[index]}
					/>
				);
			})}
		</div>
	);
};

export default InvisibleItems;
